import type React from "react";
import { useState } from "react";
import {
  ComparisonForm,
  VerticalRow,
} from "../../../components/ComparisonForm";
import EditableViewer from "../../../components/EditableViewer";
import { compareMetadatasheets } from "../../../utils/CompareMetadatasheets";

const Compare: React.FC = () => {
  const [module, setModule] = useState<File | null>(null);
  const [datasheet, setDatasheet] = useState<File | null>(null);
  const [funcname, setFuncname] = useState<string>("");
  const [varname, setVarname] = useState<string>("");

  const [moduleText, setModuleText] = useState<string>(
    "// Upload your metadata",
  );
  const [datasheetText, setDatasheetText] = useState<string>(
    "// Upload your metadata",
  );

  const [response, setResponse] = useState({});

  const handleModuleUpload = (event: React.MouseEvent) => {
    event.stopPropagation();

    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/json";

    input.onchange = (event) => {
      const file = (event.target as HTMLInputElement)?.files?.[0];

      if (file) {
        setModule(file);

        const reader = new FileReader();

        reader.onload = (e) => {
          try {
            const jsonData = JSON.stringify(
              JSON.parse(e.target?.result as string),
              null,
              2,
            );
            setModuleText(jsonData);
          } catch {
            alert("The selected file is not a valid JSON file.");
          }
        };

        reader.readAsText(file);
      }
    };

    input.click();
  };

  const handleDataUpload = (event: React.MouseEvent) => {
    event.stopPropagation();

    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/json";

    input.onchange = (event) => {
      const file = (event.target as HTMLInputElement)?.files?.[0];

      if (file) {
        setDatasheet(file);

        const reader = new FileReader();

        reader.onload = (e) => {
          try {
            const jsonData = JSON.stringify(
              JSON.parse(e.target?.result as string),
              null,
              2,
            );
            setDatasheetText(jsonData);
          } catch {
            alert("The selected file is not a valid JSON file.");
          }
        };

        reader.readAsText(file);
      }
    };

    input.click();
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!module || !datasheet) {
      alert("Please select file to upload.");
      return;
    }

    try {
      const res = await compareMetadatasheets(
        module,
        funcname,
        varname,
        datasheet,
      );
      setResponse(res);
    } catch (error) {
      alert(`Error generating comparison file. ${error}`);
    }
  };

  return (
    <div>
      <h1>Compare DataDesc Datasheets</h1>
      <h2>Drag and drop your module and dataset description to compare</h2>
      <ComparisonForm onSubmit={handleSubmit}>
        <VerticalRow>
          <EditableViewer
            title="Module Description"
            text={moduleText}
            allowUpload
            isExpandable
            customUploadFunction={handleModuleUpload}
          />
          <EditableViewer
            title="Dataset Description"
            text={datasheetText}
            allowUpload
            isExpandable
            customUploadFunction={handleDataUpload}
          />
        </VerticalRow>
        <div>
          <label>
            Function Name
            <input type="text" onChange={(e) => setFuncname(e.target.value)} />
          </label>
        </div>
        <div>
          <label>
            Data Name
            <input type="text" onChange={(e) => setVarname(e.target.value)} />
          </label>
        </div>
        <button type="submit">Submit</button>
      </ComparisonForm>
      {response && (
        <EditableViewer
          title="Result"
          text={JSON.stringify(response, null, 2)}
          allowDownload
          isExpandable
        />
      )}
    </div>
  );
};

export default Compare;
